import {Injectable} from '@angular/core';
import {
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
} from '@tisa-group/cdk';
import {Observable} from 'rxjs';
import {TisaUmpireHttpService} from '../../umpire/tisa-umpire-http.service';
import {UmpireOttEvent, UmpireOttPlaylist} from '@tisa-group/models';

@Injectable()
export class OttClientPlaylistService {
  constructor(readonly http: TisaUmpireHttpService) {}

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireOttPlaylist>> {
    return this.http
      .get(`/ott/playlists/${fetchIdentifier}`, {
        params,
      })
      .pipe(deserialize());
  }

  fetchEvents(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireOttEvent[]>> {
    return this.http
      .get(`/ott/playlists/${fetchIdentifier}/events`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }
}
